import { PersonalLanding } from '@frx/frx-program-defaults';

export const PersonalPage = () => {
  return <PersonalLanding />;
};
